import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { type DailyReportsParams, dailyReportsResponse, type UseDailyReports } from './Reports.schema';

const REPORTS_QUERY_KEY = ['reports'];

export const reportsKeys = {
	all: REPORTS_QUERY_KEY,
	daily: (params: DailyReportsParams) => [...REPORTS_QUERY_KEY, 'daily', params] as const,
};

export const useDailyReports = (params: DailyReportsParams, opts: UseDailyReports['opts'] = {}) =>
	useQuery<UseDailyReports['response']>({
		...opts,
		queryKey: reportsKeys.daily(params),
		queryFn: () => API.get('/reports/daily', { params }).then((res) => dailyReportsResponse.parse(res.data)),
		staleTime: 60_000,
	});

/**
 * Consolidated summary for a single day.
 *
 * The API generates these on the fly — one LLM call per report row — and
 * rejects `includeConsolidated` on ranges wider than 7 rows. So the table
 * lists days without them and each row asks for its own summary when the
 * operator expands it: a one-day window is always within the cap.
 */
export const useDailyConsolidated = (moduleName: string, day: string, opts: UseDailyReports['opts'] = {}) =>
	useDailyReports({ from: day, to: day, moduleName, includeConsolidated: true }, opts);
